import { Injectable } from '@angular/core';
import {ActivationEnd, Event, NavigationEnd, NavigationStart, Router} from "@angular/router";
import {ThemeService} from "./theme.service";
import {TenantService} from "../../tenant/services/tenant.service";
import {TenantConfigService} from "../../tenant/services/tenant-config.service";
import {BreadcrumbService} from "../breadcrumb/service/breadcrumb.service";
import { Location } from '@angular/common';
import {SeoService} from "./seo.service";

@Injectable({
  providedIn: 'root'
})
export class RouteListenerService {

  private MAX_HISTORY_LEN = 10; // prevent history from growing indefinitely
  private history: string[] = [];

  constructor(private router: Router,
              private themeService: ThemeService,
              private tenantService: TenantService,
              private tenantConfigService: TenantConfigService,
              private breadcrumbService: BreadcrumbService,
              private location: Location,
              private seoService: SeoService) {

    router.events.subscribe((event: Event) => {

      // see also
      if (event instanceof NavigationStart) {

        // Set default seo tags on each page changes. It can be overriden in components
        this.seoService.generateTags({});

        /*const currentTenant = this.tenantService.getTenant();
        const newTenant = this.tenantService.getTenant(event.url);

        console.log("current", currentTenant);
        console.log("new", newTenant);
        console.log("event", event);

        if(currentTenant !== newTenant) {
          this.themeService.setTheme(newTenant + "");
          this.tenantConfigService.load();
        }*/
      } else if(event instanceof NavigationEnd) {

        this.history.push(event.urlAfterRedirects);
        if (this.history.length > this.MAX_HISTORY_LEN) {
          this.history.shift();
        }
      }
    });
  }

  back(): void {
    this.history.pop();
    if (this.history.length > 0) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/dashboard');
    }
  }
}
